import { render, staticRenderFns } from "./ShipBluTable.vue?vue&type=template&id=66fd9347"
import script from "./ShipBluTable.vue?vue&type=script&lang=js"
export * from "./ShipBluTable.vue?vue&type=script&lang=js"
import style0 from "./ShipBluTable.vue?vue&type=style&index=0&id=66fd9347&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports